<div class="selectors-container">
    <div class="selectors-row">
        <div class="selector-wrapper">
            <div>{{ 'sensor-cable-tag.filter.fcu' | translate }}</div>
            <div class="selector" [class.disabledSelector]="disabled" [class.open]="isFcuSelectorOpen" (click)="openFcuSelector($event)" #fcuSelElement>
                <ng-container
                    *ngTemplateOutlet="
                        selectorTemplate;
                        context: {
                            displayValue: getDisplayValue(fcuSelector),
                            isOpen: isFcuSelectorOpen,
                            options: getSelectorOptions(fcuSelector),
                            onSelect: optionSelected.bind(this, fcuSelector),
                            formatOption: formatFcu.bind(this),
                        }
                    " />
            </div>
        </div>

        <div class="selector-wrapper">
            <div>{{ 'sensor-cable-tag.filter.fu' | translate }}</div>
            <div
                class="selector"
                [class.disabledSelector]="!selectedFcuNum || disabled"
                [class.open]="isFuSelectorOpen"
                (click)="openFuSelector($event)"
                #fuSelElement>
                <ng-container
                    *ngTemplateOutlet="
                        selectorTemplate;
                        context: {
                            displayValue: getDisplayValue(fuSelector),
                            options: getSelectorOptions(fuSelector),
                            isOpen: isFuSelectorOpen,
                            onSelect: optionSelected.bind(this, fuSelector),
                            formatOption: formatFu.bind(this),
                        }
                    " />
            </div>
        </div>

        <div class="selector-wrapper">
            <div>{{ 'sensor-cable-tag.filter.slot' | translate }}</div>
            <div
                class="selector"
                [class.disabledSelector]="(!selectedFuNum && selectedFuNum != NO_SELECTION) || disabled"
                [class.open]="isSlotSelectorOpen"
                (click)="openSlotSelector($event)"
                #slotSelElement>
                <ng-container
                    *ngTemplateOutlet="
                        selectorTemplate;
                        context: {
                            displayValue: getDisplayValue(slotSelector),
                            isOpen: isSlotSelectorOpen,
                            options: getSelectorOptions(slotSelector),
                            onSelect: optionSelected.bind(this, slotSelector),
                            formatOption: paddNumber.bind(this),
                        }
                    " />
            </div>
        </div>
    </div>
</div>

<ng-template
    #selectorTemplate
    let-displayValue="displayValue"
    let-isOpen="isOpen"
    let-options="options"
    let-onSelect="onSelect"
    let-formatOption="formatOption">
    <div>{{ displayValue }}</div>
    <mat-icon class="arrow" svgIcon="dropdown-arrow" />
    <ng-container *ngIf="isOpen">
        <div class="options-wrapper" #selectorElement [style.top]="optionsTop" [style.left]="optionsLeft">
            <div *ngFor="let option of options" class="selector-option" (click)="onSelect(option)" [class.selected]="option === displayValue">
                {{ formatOption(option) }}
            </div>
        </div>
    </ng-container>
</ng-template>
